export const salesLocationsKeys = {
  all: ["salesLocations"] as const,
  lists: () => [...salesLocationsKeys.all, "list"] as const,
  list: (filters: Record<string, unknown> = {}) =>
    [...salesLocationsKeys.lists(), { filters }] as const,
}
